<script>
import cardCommercial from './card-commercial'
import store from '../store'

export default {
  name: 'infoDialog',
  components: {
    cardCommercial
  },
  props: {
    header: String
  },
  computed: {
    showDialog: {
      get: function () {
        let modelState = this.$store.getters['model/getState']
        return modelState.infoDialog
      },
      set: function (newValue) {
        store.commit('model/setProperty', {property: 'infoDialog', value: newValue})
      }
    }
  }
}
</script>

<template>
  <md-dialog class="masonry" :md-active.sync="showDialog">
    <md-dialog-content>

      <cardCommercial class="md-primary"/>

      <md-card >
        <md-card-header>
          <div class="md-title">{{header}}</div>
        </md-card-header>

        <md-card-content>
          This configurator is a demo with a template design. It gives you a taste of what realtime 3D configuration offers.<br>
          Check out the fully designed examples to see our custom designed projects.
        </md-card-content>
      </md-card>

      <md-card>
        <md-card-media>
          <!-- <img src={zodiacImg} alt="Zodiac Nautic"/> -->
          <img src="../assets/img/zodiac.jpg" alt="Zodiac Nautic"/>
        </md-card-media>

        <md-card-header>
          <div class="md-title">Zodiac Nautic</div>
          <div class="md-subhead">Semi inflatable boats</div>
        </md-card-header>

        <md-card-content>
          A bespoke configurator. Lots of color options and different products to choose from. Review and checkout your design and get a pdf with your design emailed to you automatically.
        </md-card-content>

        <md-card-actions>
          <md-button href="https://configure.zodiac-nautic.com/" target="_blank">Visit</md-button>
          <md-button href="https://www.klaasnienhuis.nl/2016/07/zodiac-nautic-boat-configurator/" target="_blank">Read more</md-button>
        </md-card-actions>
      </md-card>

      <md-card>
        <md-card-media>
          <!-- <img src={fdomesImg} alt="F.Domes"/> -->
          <img src="../assets/img/fdomes.jpg" alt="F.Domes"/>
        </md-card-media>

        <md-card-header>
          <div class="md-title">F.Domes</div>
          <div class="md-subhead">Geodetic dome tents</div>
        </md-card-header>

        <md-card-content>
          A custom configurator with a responsive design. Speed up the sales process with live princing and shipping info.
        </md-card-content>

        <md-card-actions>
          <md-button href="https://3d.fdomes.com/" target="_blank">Visit</md-button>
          <md-button href="https://www.klaasnienhuis.nl/2018/06/f-domes-geodesic-dome-configurator/" target="_blank">Read more</md-button>
        </md-card-actions>
      </md-card>

    </md-dialog-content>
    <md-dialog-actions md-elevation="5">
      <md-button class="md-accent md-raised" @click="showDialog = false">OK, cool</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<style lang="scss" scoped>
  .md-dialog {
    min-width: 740px;

    @media screen and (max-width: 768px) {
      min-width: 100%;
      min-height: 100%;
    }
    @media screen and (min-width: 1279px) {
      max-width: 740px;
    }
  }
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
</style>
